var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#fe9900;}.b{clip-path:url(#a);}.c{fill:#fe9900;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 75,
    height: 75,
    transform: "translate(648 188)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-648 -188)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M17.587,82.622H76.838a7.867,7.867,0,0,0,6.806-11.8L54.019,19.633a7.865,7.865,0,0,0-13.613,0L10.78,70.819a7.867,7.867,0,0,0,6.806,11.8ZM47.213,55.081a3.946,3.946,0,0,1-3.934-3.934V43.278a3.934,3.934,0,0,1,7.869,0v7.869A3.946,3.946,0,0,1,47.213,55.081Zm3.934,15.738H43.278V62.95h7.869Z",
    transform: "translate(638.287 176.335)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.9b44d334e67d29da360c9d32d8e8cd30.svg";
export { ForwardRef as ReactComponent };